import { isString } from 'lodash';
import {
  IMethodAttributes,
  IOriginalMethodAttributes,
  IPreemptive,
  IPublishedRestScope,
} from '~shared/types/code-editor';

export function parseAttributes(content: string): IMethodAttributes {
  let parsed = {} as IOriginalMethodAttributes;
  try {
    const attributes = content.match(/\/\/%attributes = (.*)/)?.[1] || '';
    parsed = JSON.parse(attributes);
  } catch (err) {
    // proceed
  }

  const { published4DMobile, ...rest } = parsed;
  const defaults: IMethodAttributes = {
    invisible: false,
    shared: false,
    executedOnServer: false,
    preemptive: IPreemptive.indifferent,
    publishedSoap: false,
    publishedWsdl: false,
    publishedWeb: false,
    publishedSql: false,
    publishedRest: !!published4DMobile,
    publishedRestOptions: published4DMobile
      ? published4DMobile
      : {
          table: '',
          scope: IPublishedRestScope.table,
        },
  };

  return {
    ...defaults,
    ...rest,
  };
}

export function stringifyAttributes(
  attributes: Partial<IMethodAttributes>,
): string {
  const attrs: IOriginalMethodAttributes = {} as IOriginalMethodAttributes;
  if (attributes.invisible) {
    attrs.invisible = true;
  }
  if (attributes.shared) {
    attrs.shared = true;
  }
  if (attributes.executedOnServer) {
    attrs.executedOnServer = true;
  }
  if (
    attributes.preemptive &&
    [IPreemptive.capable, IPreemptive.incapable].includes(attributes.preemptive)
  ) {
    attrs.preemptive = attributes.preemptive;
  }
  if (attributes.publishedSoap) {
    attrs.publishedSoap = true;
    if (attributes.publishedWsdl) {
      attrs.publishedWsdl = true;
    }
  }
  if (attributes.publishedWeb) {
    attrs.publishedWeb = true;
  }
  if (attributes.publishedSql) {
    attrs.publishedSql = true;
  }
  if (attributes.publishedRest && attributes.publishedRestOptions) {
    attrs.published4DMobile = attributes.publishedRestOptions;
  }

  return JSON.stringify(attrs).replace(/"(true|false)"/g, '$1');
}

export function addAttributesToContent(
  content: string,
  attributes: string | Partial<IMethodAttributes>,
  override: boolean = false,
): string {
  const attrs = isString(attributes)
    ? attributes
    : stringifyAttributes(attributes);

  if (!override && hasAttributesString(content)) {
    return content;
  }

  const cleanedContent = removeAttributesString(content);

  return `//%attributes = ${attrs}\r\n${cleanedContent}`;
}

export function hasAttributesString(content: string) {
  return /^\/\/%attributes.*(?:\r\n|\n)?/g.test(content);
}

export function removeAttributesString(content: string) {
  return content.replace(/^\/\/%attributes.*(?:\r\n|\n)?/g, '');
}
